import { Slot } from "expo-router";

export default function RoutesLayout() {
  return <Slot />;
}
